export default __webpack_public_path__ + "static/media/estado-32.48518b3c.svg";